<template>
  <div class="flex flex-col gap-4 p-4">
    <RouterLink
      v-for="menuEntry in menuEntries"
      :key="menuEntry.id"
      :to="menuEntry.route"
      class="squircle-md flex aspect-square w-12 items-center justify-center rounded bg-white p-1 shadow-xl"
    >
      <img :src="menuEntry.img.src" />
    </RouterLink>
  </div>
</template>

<script>
import { Partners } from '@/assets/enums/index.js'
import PartnersMiniLogo from '@/assets/enums/config/PartnersMiniLogo.js'

export default {
  name: 'RightMenu',
  computed: {
    menuEntries() {
      return [
        {
          id: 'elys',
          route: {
            name: 'partners_elys_page_route'
          },
          gate: this.$functionality.module.has('elys'),
          img: {
            src: PartnersMiniLogo[Partners.ELYS]
          }
        },
        {
          id: 'enaos',
          route: {
            name: 'partners_enaos_page_route'
          },
          gate: this.$functionality.module.has('enaos'),
          img: {
            src: PartnersMiniLogo[Partners.ENAOS]
          }
        }
      ].filter((entry) => entry.gate)
    }
  }
}
</script>
